export const SITE_ORIGIN = "https://tlcassociates.llc";
export const ORGANIZATION_ID = "https://s3.amazonaws.com/slstacks/tlcassociates/id.html";
const LOGO_ID = `${SITE_ORIGIN}/#logo`;
const WEBSITE_ID = `${SITE_ORIGIN}/#website`;
const SCHEMA_MODIFIED_DATE = "2026-10-05";

// These QIDs were matched by exact enwiki sitelink title in one Wikidata API call.
const areaLinks = (title: string, qid: string) => [
  `https://en.wikipedia.org/wiki/${title.replaceAll(" ", "_")}`,
  `https://www.wikidata.org/wiki/${qid}`,
];

export const norfolkCounty = {
  "@type": "AdministrativeArea",
  name: "Norfolk County, Massachusetts",
  sameAs: areaLinks("Norfolk County, Massachusetts", "Q54079"),
};

const townAreas = [
  ["Franklin", "Q942254"],
  ["Bellingham", "Q521279"],
  ["Medway", "Q2536948"],
  ["Norfolk", "Q2302443"],
  ["Wrentham", "Q2536885"],
].map(([town, qid]) => ({
  path: `/service-areas/${town.toLowerCase()}`,
  area: {
    "@type": "City",
    name: `${town}, MA`,
    sameAs: areaLinks(`${town}, Massachusetts`, qid),
  },
}));

const sameAs = [
  "https://www.google.com/maps?cid=7457328068829562039",
  "https://www.houzz.com/hznb/professionals/landscape-contractors/tlc-associates-llc-pfvwus-pf~978583734",
  "https://www.manta.com/c/m1hh5xb/tlc-associates-llc",
  "https://www.merchantcircle.com/tlc-associates--franklin-ma",
  "https://sites.bubblelife.com/community/tlc_associates_llc",
  "https://www.provenexpert.com/tlc-associates-llc/",
  "https://www.storeboard.com/tlcassociatesllc",
  "https://www.brownbook.net/business/55191619/tlc-associates-llc",
  "https://tupalo.com/en/franklin-massachusetts/tlc-associates-llc",
  "https://www.callupcontact.com/b/businessprofile/TLC_Associates_LLC/10121067",
  "https://www.hotfrog.com/company/d16a8cdec4e9ee6752bcd920820965c3/tlc-associates-llc/franklin/home-improvement",
  "https://www.cybo.com/US-biz/tlc-associates-llc_70",
  "https://www.trepup.com/store/tlcassociates/profile",
  "https://us.enrollbusiness.com/BusinessProfile/7836939/TLC-Associates-LLC-Franklin-MA-02038/",
  "https://ezlocal.com/ma/franklin/landscaper/0919706818",
  "https://tlc-associates-llc.hub.biz/",
  "https://agreatertown.com/franklin-ma/tlc-associates-llc-0002300363740",
  "https://www.linkcentre.com/profile/tlcassociates/",
  "https://citysquares.com/b/tlc-associates-llc-27193089",
  "https://www.n49.com/biz/7239555/tlc-associates-llc-ma-franklin-149-west-central-street/",
  "https://www.find-us-here.com/businesses/TLC-Associates-LLC-Franklin-Massachusetts-USA/34532662/",
  "https://www.freelistingusa.com/listings/tlc-associates-llc",
  "https://www.anibookmark.com/business/tlc-associates-llc-bs491194.html",
  "https://www.trustlink.org/Reviews/TLC-Associates-LLC-207664722",
  "https://www.facebook.com/people/TLC-Associates/100067314530324/",
  "https://www.instagram.com/tlc.property/",
  "https://www.8coupons.com/stores/local/tlc-associates-llc-franklin-02038-2090327082",
  "https://maps.apple.com/place?auid=11461260383277593482",
  "http://www.yext.com/partnerpages/aroundme/tlc-associates-llc-franklin-massachusetts-us-609a84",
  "http://www.bing.com/maps?ss=ypid.E0592DE408C9A5BC&mkt=en-US",
  "https://www.chamberofcommerce.com/business-directory/massachusetts/franklin/landscaper/2034507328-tlc-associates-llc",
  "https://citysquares.com/b/tlc-associates-llc-28023783",
  "https://www.cylex.us.com/company/tlc-associates-llc-40727125.html",
  "http://www.dexknows.com/franklin-ma/bp/tlc-associates-582718551",
  "https://www.elocal.com/profile/25314276",
  "http://ezlocal.com/ma/franklin/landscape-designer/0919706818",
  "https://www.golocal247.com/biz/tlc-associates-llc/franklin-ma/YEXT4325755",
  "https://www.hotfrog.com/company/AWH_Jd0Bdvim6YC0y9Iwgg/tlc-associates-llc/franklin/lawn-garden",
  "https://www.hours.com/us/TLC-Associates-LLC/Franklin/149-W-Central-St/",
  "https://www.ibegin.com/directory/visit/20847714",
  "https://www.iglobal.co/united-states/franklin/tlc-associates-llc",
  "http://www.mapquest.com/places/-814787829/",
  "https://www.mylocalservices.com/TLC+Associates+LLC-Franklin-Massachusetts-27481516.html",
  "https://www.n49.com/biz/7239555",
  "http://www.yext.com/partnerpages/navmii/tlc-associates-llc-franklin-massachusetts-us-609a84",
  "https://nextdoor.com/page/tlc-associates-llc-franklin-ma/",
  "https://franklin-ma.opendi.us/13967138.html",
  "https://maps.propertycapsule.com/internal/listing/4394107/profile",
  "https://www.showmelocal.com/profile.aspx?bid=40369299",
  "http://www.superpages.com/franklin-ma/bpp/tlc-associates-582718551",
  "https://www.tellows.com/num/5085051539",
  "https://www.tupalo.co/franklin-massachusetts/tlc-associates-llc",
  "https://uscity.net/listing/tlc_associates_llc-12442289",
  "https://wheretoapp.com/search?poi=7457328068829562039",
  "https://wogibtswas.de/location/2545076-yext",
  "https://www.yellowpagesdirectory.com/?page=show&state=MA&id=382704",
  "https://www.yelp.com/biz/tlc-associates-franklin?adjust_creative=MFyzcjahxBMNAyHg85HGjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_lookup&utm_source=MFyzcjahxBMNAyHg85HGjg",
  "http://www.yellowpages.com/franklin-ma/mip/tlc-associates-582718551?from=yext",
];

const offer = (name: string, path?: string) => ({
  "@type": "Offer",
  itemOffered: {
    "@type": "Service",
    name,
    ...(path ? { url: `${SITE_ORIGIN}${path}` } : {}),
  },
});

export const organizationSchema = {
  "@type": "HomeAndConstructionBusiness",
  "@id": ORGANIZATION_ID,
  additionalType: "https://www.wikidata.org/wiki/Q8070591",
  name: "TLC Associates LLC",
  legalName: "TLC Associates LLC",
  foundingDate: "2018-04",
  url: `${SITE_ORIGIN}/`,
  telephone: "+1-508-505-1539",
  email: "tlcproperty149@gmail.com",
  description: "TLC Associates LLC is a landscaping company based in Franklin, Massachusetts, providing landscape maintenance, lawn care, landscaping, garden and planting, landscape renovation, tree and shrub care, stonework and hardscaping, commercial landscaping, skid steer services, and snow plowing for residential and commercial properties in Franklin, Bellingham, Medway, Norfolk, Wrentham, and Norfolk County.",
  logo: { "@id": LOGO_ID },
  image: `${SITE_ORIGIN}/tlc-logo.png`,
  address: {
    "@type": "PostalAddress",
    streetAddress: "149 West Central Street",
    addressLocality: "Franklin",
    addressRegion: "MA",
    postalCode: "02038",
    addressCountry: "US",
  },
  areaServed: [
    norfolkCounty,
    ...townAreas.map(({ area }) => area),
  ],
  sameAs,
  subjectOf: {
    "@type": "WebPage",
    url: "https://s3.amazonaws.com/slstacks/tlcassociates/id.html",
    name: "TLC Associates LLC - Landscaper Franklin, Massachusetts",
  },
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Landscaping Services",
    itemListElement: [
      offer("Landscape Maintenance"),
      offer("Lawn Care", "/lawn-care"),
      offer("Landscaping", "/landscaping"),
      offer("Garden & Planting", "/garden-and-planting"),
      offer("Landscape Renovation", "/landscape-renovation"),
      offer("Tree & Shrub Care", "/tree-and-shrub-care"),
      offer("Stonework & Hardscaping", "/stonework"),
      offer("Commercial Landscaping", "/commercial-services"),
      offer("Skid Steer Services", "/commercial-services/skid-steer-services"),
      offer("Snow Plowing", "/snow-plowing"),
    ],
  },
};

export function serviceSchema(
  path: string,
  name: string,
  serviceType?: string,
) {
  return {
    "@type": "Service",
    name,
    ...(serviceType ? { serviceType } : {}),
    provider: { "@id": ORGANIZATION_ID },
    areaServed: norfolkCounty,
    url: `${SITE_ORIGIN}${path}`,
  };
}

export function pageSchema(
  path: string,
  type: "WebPage" | "CollectionPage" | "ContactPage",
  name: string,
  description: string,
) {
  return {
    "@context": "https://schema.org",
    "@type": type,
    name,
    url: `${SITE_ORIGIN}${path}`,
    description,
    about: { "@id": ORGANIZATION_ID },
  };
}

export function buildPageSchemaGraph(
  path: string,
  title: string,
  description: string,
  sourceSchema: object,
  h1?: string,
) {
  const source = sourceSchema as Record<string, unknown>;
  const pageUrl = path === "/" ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${path}`;
  const pageId = `${pageUrl}#webpage`;
  const breadcrumbId = `${pageUrl}#breadcrumb`;
  const townArea = townAreas.find((town) => town.path === path)?.area;
  const heading = h1?.trim();
  const breadcrumbName = townArea?.name
    ?? (heading && heading.length < 40 ? heading : title.split(" | ")[0].trim());
  const sourceService = source["@type"] === "Service" ? source : townArea ? {
    ...serviceSchema(path, `Landscaping Services in ${townArea.name}`, "Landscaping"),
    areaServed: townArea,
  } : undefined;
  const service = sourceService
    ? { ...sourceService, "@id": `${pageUrl}#service` }
    : undefined;

  return {
    "@context": "https://schema.org",
    "@graph": [
      organizationSchema,
      {
        "@type": "ImageObject",
        "@id": LOGO_ID,
        url: `${SITE_ORIGIN}/tlc-logo.png`,
        contentUrl: `${SITE_ORIGIN}/tlc-logo.png`,
      },
      {
        "@type": "WebSite",
        "@id": WEBSITE_ID,
        url: `${SITE_ORIGIN}/`,
        name: "TLC Associates LLC",
        publisher: { "@id": ORGANIZATION_ID },
      },
      {
        "@type": source["@type"] === "ContactPage" ? "ContactPage" : "WebPage",
        "@id": pageId,
        url: pageUrl,
        name: title,
        description,
        isPartOf: { "@id": WEBSITE_ID },
        about: { "@id": ORGANIZATION_ID },
        breadcrumb: { "@id": breadcrumbId },
        dateModified: SCHEMA_MODIFIED_DATE,
        ...(service ? { mainEntity: { "@id": service["@id"] } } : {}),
      },
      {
        "@type": "BreadcrumbList",
        "@id": breadcrumbId,
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: `${SITE_ORIGIN}/`,
          },
          ...(path === "/" ? [] : [{
            "@type": "ListItem",
            position: 2,
            name: breadcrumbName,
            item: pageUrl,
          }]),
        ],
      },
      ...(service ? [service] : []),
    ],
  };
}